import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCouponALV1Component } from './product-coupon-al-v1/product-coupon-al-v1.component';
import {ProductCouponALV2Component} from './product-coupon-al-v2/product-coupon-al-v2.component'



@NgModule({
  declarations: [ProductCouponALV1Component, ProductCouponALV2Component],
  exports: [
    ProductCouponALV1Component,
    ProductCouponALV2Component
  ],
  imports: [
    CommonModule
  ],
  providers: [
    ProductCouponALV1Component,
  ]
})
export class ProductCouponModule { }
